import { ToastContext } from '@providers/ToastProvider'
import { useContext } from 'react'

export default function useToast() {
  return useContext(ToastContext)
}
